export const _findHealthInsuranceData = [
    {
        name: `Medicare`,
        links: [
            {
                url: '/medicare',
                text: 'Medicare Insurance',
                'data-wa': `top nav:Medicare Insurance`,
            },
            {
                url: '/medicare/advantage-all/medicare-advantage',
                text: 'Medicare Advantage',
                'data-wa': `top nav:Medicare Advantage`,
            },
            {
                url: '/medicare/supplement-all/medicare-supplement-plans',
                text: 'Medicare Supplement',
                'data-wa': `top nav:Medicare Supplement`,
            },
            {
                url:
                    '/medicare/part-d-all/medicare-part-d-prescription-drug-coverage',
                text: 'Medicare Part D',
                'data-wa': `top nav:Medicare Part D`,
            },
        ],
        key: 'medicare'
    },
    {
        name: `Individual & Family`,
        links: [
            {
                text: `Individual & Family Health Insurance`,
                url: `/individual-family-health-insurance`,
                'data-wa': `top nav:Individual & Family Health Insurance`,
            },
            {
                text: `Short-term Health Insurance`,
                url: `/short-term-health-insurance`,
                'data-wa': `top nav:Short-term Health Insurance`,
            },
            {
                text: `Dental Insurance`,
                url: `/dental-insurance`,
                'data-wa': `top nav:Dental Insurance`,
            },
            {
                text: `Vision Insurance`,
                url: `/vision-insurance`,
                'data-wa': `top nav:Vision Insurance`,
            },
        ],
        key: 'ifp'
    },
    {
        name: `Small Business`,
        links: [
            {
                url: '/small-business-health-insurance',
                text: 'Small Business Health Insurance',
                'data-wa': `top nav:Small Business Health Insurance`,
            },
            {
                url: '/group-dental-insurance',
                text: 'Group Dental Insurance',
                'data-wa': `top nav:Group Dental Insurance`,
            },
            {
                url: '/group-vision-insurance',
                text: 'Group Vision Insurance',
                'data-wa': `top nav:Group Vision Insurance`,
            },
        ],
        key: 'smb'
    },
    {
        name: `Other Insurance Products`,
        links: [
            {
                url: '/supplemental-health-insurance',
                text: 'GAP Insurance',
                'data-wa': `top nav:GAP Insurance`,
            },
            {
                url: '/medical-indemnity-insurance',
                text: 'Medical Indemnity Insurance',
                'data-wa': `top nav:Medical Indemnity Insurance`,
            },
        ],
        key: 'other'
    },
];

export const _learnTemplateDataIFPSMB = [
    {
        name: `Medicare`,
        links: [
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                    ""}ehealthinsurance.com/medicare/advantage-all/medicare-advantage`,
                text: 'Medicare Advantage',
                'data-wa': `top nav:Medicare Advantage`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/advantage-all/medicare-advantage-plan-costs`,
                text: 'Medicare Advantage Cost',
                'data-wa': `top nav:Medicare Advantage Cost`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/advantage-all/comparing-medicare-advantage-plans`,
                text: 'Compare Medicare Advantage Plans',
                'data-wa': `top nav:Compare Medicare Advantage Plans`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/medicare-advantage-vs-medicare-supplement-plans`,
                text: 'Medigap vs Medicare Advantage',
                'data-wa': `top nav:Medigap vs Medicare Advantage`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/medigap-plans`,
                text: 'What is Medigap',
                'data-wa': `top nav:What is Medigap`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/medicare-supplement-plan-costs`,
                text: 'Medigap Cost',
                'data-wa': `top nav:Medigap Cost`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/medicare-supplement-plans`,
                text: 'Medicare Supplement Plans',
                'data-wa': `top nav:Medicare Supplement Plans`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/compare-medicare-supplement-plans`,
                text: 'Compare Medicare Supplement Plans',
                'data-wa': `top nav:Compare Medicare Supplement Plans`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/supplement-all/medicare-supplement-enrollment`,
                text: 'Enrolling in Medicare Supplement Plans',
                'data-wa': `top nav:Enrolling in Medicare Supplement Plans`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/part-d-all/medicare-part-d-prescription-drug-coverage`,
                text: 'Medicare Part D',
                'data-wa': `top nav:Medicare Part D`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/part-d-all/medicare-part-d-prescription-drug-coverage-costs`,
                text: 'Medicare Part D Costs',
                'data-wa': `top nav:Medicare Part D Costs`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/medicare/part-d-all/comparing-medicare-part-d-coverage`,
                text: 'Compare Medicare Part D Plans',
                'data-wa': `top nav:Compare Medicare Part D Plans`,
            },
        ],
        key: 'medicarelearn'
    },
    {
        name: `Individual & Family`,
        links: [
            {
                text: `Health Insurance Resource Center`,
                url: `/resources`,
                'data-wa': `top nav:Health Insurance Resource Center`,
            },
            {
                text: `Affordable Care Act`,
                url: `/resources/affordable-care-act`,
                'data-wa': `top nav:Affordable Care Act`,
            },
            {
                text: `Frequently Asked Questions`,
                url: `/resources/frequently-asked-questions`,
                'data-wa': `top nav:Frequently Asked Questions`,
            },
            {
                text: `Vision Insurance`,
                url: `/vision-insurance`,
                'data-wa': `top nav:Vision Insurance`,
            },
        ],
        key: 'ifplearn'
    },
    {
        name: `Small Business`,
        links: [
            {
                url:
                    '/small-business-health-insurance/small-business-preparation-checklist',
                text: 'Application Checklist',
                'data-wa': `top nav:Application Checklist`,
            },
            {
                url:
                `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/resources/small-business`,
                text: 'Small Business Resource Center',
                'data-wa': `top nav:Small Business Resource Center`,
            },
            {
                url: '/small-business-health-insurance/buyers-guide',
                text: 'Guide for Buying Small Business Health Insurance',
                'data-wa': `top nav:Guide for Buying Small Business Health Insurance`,
            },
            {
                url: '/small-business-health-insurance/shop-marketplace',
                text: 'SHOP Marketplace Guide',
                'data-wa': `top nav:SHOP Marketplace Guide`,
            },
        ],
        key: 'smblearn'
    },
];

export const _aboutTemplateData = {
    links: [
        {
            url: '/about-ehealth-index',
            text: 'About eHealth',
            'data-wa': `top nav:About eHealth`,
        },
        {
            url: '/about-ehealth/customer-promise',
            text: 'Customer Promise',
            'data-wa': `top nav:Customer Promise`,
        },
        {
            url: '/resources',
            text: 'Resource Center',
            'data-wa': `top nav:Resource Center`,
        },
        {
            url: '//ir.ehealthinsurance.com',
            text: 'Investor Relations',
            'data-wa': `top nav:Investor Relations`,
        },
        {
            url: '/about-ehealth/information-security',
            text: 'Information Security',
            'data-wa': `top nav:Information Security`,
        },
        {
            url: '//news.ehealthinsurance.com',
            text: 'Newsroom',
            'data-wa': `top nav:Newsroom`,
        },
        {
            url: '/about-ehealth/careers-benefit',
            text: 'Careers',
            'data-wa': `top nav:Careers`,
        },
        {
            url: '/about-ehealth/contact-us',
            text: 'Contact & Support',
            'data-wa': `top nav:Contact & Support`,
        },
    ],
};
